import React from 'react';
import { SalesFunnel } from './pages/SalesFunnel';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <SalesFunnel data-id="element-1" />
    </>;
}